import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const relationshipsToSubscriberSelector = (state: RootState) =>
  state.amwell.system.relationshipsToSubscriber;

export const relationshipsToSubscriberDataSelector = createSelector(
  relationshipsToSubscriberSelector,
  rts => rts.data
);
export const relationshipsToSubscriberDataErrorSelector = createSelector(
  relationshipsToSubscriberSelector,
  rts => rts.error
);
export const relationshipsToSubscriberDataLoadingSelector = createSelector(
  relationshipsToSubscriberSelector,
  rts => rts.loading
);
